/**
 * A small accessible on/off switch (`role="switch"`). The design system has no
 * toggle primitive, so this is the shared one — used to activate/deactivate a
 * capability's data source with one click.
 */
interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  /** Accessible label — what the switch turns on/off. */
  label: string;
  disabled?: boolean;
}

export const Toggle = ({ checked, onChange, label, disabled = false }: ToggleProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={onChange}
    className={`relative inline-flex h-6 w-11 flex-none items-center rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-50 ${
      checked ? 'bg-success' : 'bg-outline'
    }`}
  >
    <span
      className={`inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow transition-transform ${
        checked ? 'translate-x-[22px]' : 'translate-x-[3px]'
      }`}
    />
  </button>
);
